import React, { createContext, useEffect, useMemo, useState, ReactNode } from 'react';

import { adapters as initialAdapters } from './adapters';
import { LitecoinWalletAdapter, SignPsbtLtcOptions } from './types';

interface LitecoinContextProps {
  isConnected: boolean;
  address: string | null;
  connect: () => Promise<void>;
  getPublicKey: () => Promise<string | null>;
  signPsbt: (psbt: string, options?: SignPsbtLtcOptions) => Promise<string>;
  disconnect: () => void;
  adapterName: string;
}

export const LitecoinContext = createContext<LitecoinContextProps | undefined>(undefined);

export const LitecoinProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const adapters = useMemo(() => initialAdapters, [initialAdapters]);
  const [adapter, setAdapter] = useState<LitecoinWalletAdapter>(adapters[0]);
  const [isConnected, setIsConnected] = useState(false);
  const [address, setAddress] = useState<string | null>(null);

  useEffect(() => {
    const adapter = adapters[0];
    setAdapter(adapter);
  }, [adapters]);

  const connect = async () => {
    await adapter.connect();
    setIsConnected(adapter.isConnected);

    setAddress(adapter.address);
  };

  const getPublicKey = async () => adapter.getPublicKey();
  const signPsbt = async (psbt: string, options?: SignPsbtLtcOptions) => adapter.signPsbt(psbt, options);
  const disconnect = () => {
    adapter.disconnect();
    setIsConnected(false);
    setAddress(null);
  };

  return (
    <LitecoinContext.Provider
      value={{
        isConnected,
        address,
        connect,
        getPublicKey,
        signPsbt,
        disconnect,
        adapterName: adapter.name,
      }}
    >
      {children}
    </LitecoinContext.Provider>
  );
};
